// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
import HowToRegIcon from '@mui/icons-material/HowToReg';
import DescriptionIcon from '@mui/icons-material/Description';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  transactions: icon("ic_transactions"),
  settings: icon("ic_settings"),
  dashboard: icon("ic_home"),
  employee: icon("ic_people"),
  customer: icon("ic_customer"),
  calendar: icon("ic_calendar"),
  file: icon("ic_file"),
  document: <DescriptionIcon />,
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    items: [
      {
        title: "Home",
        path: PATH_DASHBOARD.home,
        icon: ICONS.dashboard,
        roles: ["Administrator", "Employee"],
      },
      {
        title: "Employee Profiles",
        path: PATH_DASHBOARD.employeeProfile,
        icon: ICONS.employee,
        roles: ["Administrator", "Employee"],
      },
      {
        title: "Customer Profiles",
        path: PATH_DASHBOARD.customerProfile,
        icon: ICONS.customer,
        roles: ["Administrator"],
      },
      {
        title: "Schedules",
        path: PATH_DASHBOARD.schedules,
        icon: ICONS.calendar,
        roles: ["Administrator"],
      },
      {
        title: "Time Off Requests",
        path: PATH_DASHBOARD.timeOffRequests,
        icon: ICONS.calendar,
        roles: ["Administrator"],
      },
      {
        title: "Shift Templates",
        path: PATH_DASHBOARD.shiftTemplate,
        icon: ICONS.calendar,
        roles: ["Administrator"],
      },
      {
        title: "Post Order",
        path: PATH_DASHBOARD.postOrderEditor,
        icon: ICONS.calendar,
        roles: ["Administrator"],
      },
      {
        title: "Contacts",
        path: PATH_DASHBOARD.contacts,
        icon: ICONS.transactions,
        roles: ["Administrator"],
      },
      {
        title: "Job Requisitions",
        path: PATH_DASHBOARD.jobs,
        icon: ICONS.file,
        roles: ["Administrator"],
      },
      {
        title: "Job Applications",
        path: PATH_DASHBOARD.applications,
        icon: ICONS.user,
        roles: ["Administrator"],
      },
      {
        title: 'Fleet Management',
        path: PATH_DASHBOARD.fleetDashboard,
        icon: ICONS.dashboard,
        roles: ['Administrator'],
        children: [
          {
            title: 'Dashboard',
            path: PATH_DASHBOARD.fleetDashboard,
            roles: ['Administrator'],
          },
          {
            title: 'Vehicles',
            path: PATH_DASHBOARD.fleetVehicles,
            roles: ['Administrator'],
          },
          // {
          //   title: 'Drivers',
          //   path: PATH_DASHBOARD.fleetDrivers,
          //   roles: ['Administrator'],
          // },
          {
            title: 'Registrations',
            path: '/registrations',
            roles: ['Administrator'],
          },
          {
            title: 'Insurance',
            path: PATH_DASHBOARD.insurancePolicies,
            roles: ['Administrator'],
          },
          // {
          //   title: 'Driver Approval Requests',
          //   path: PATH_DASHBOARD.driverApprovalRequests,
          //   roles: ['Administrator'],
          // },
          // {
          //   title: 'Certificate Requests',
          //   path: PATH_DASHBOARD.certificateRequests,
          //   roles: ['Administrator'],
          // },
          {
            title: 'Maintenance',
            path: PATH_DASHBOARD.fleetMaintenance,
            roles: ['Administrator'],
          },
          // {
          //   title: 'Trips',
          //   path: PATH_DASHBOARD.fleetTrips,
          //   roles: ['Administrator'],
          // },
          {
            title: 'Fuel Logs',
            path: PATH_DASHBOARD.fleetFuelLogs,
            roles: ['Administrator'],
          },
          {
            title: 'Inspections',
            path: PATH_DASHBOARD.fleetInspections,
            roles: ['Administrator'],
          },
          {
            title: 'Work Orders',
            path: PATH_DASHBOARD.fleetWorkOrders,
            roles: ['Administrator'],
          },
          // {
          //   title: 'Defect Reports',
          //   path: '/fleet/defect-reports',
          //   roles: ['Administrator', 'Employee'],
          // },
        ],
      },
      // {
      //   title: 'Daily Activity Reports',
      //   path: PATH_DASHBOARD.dar.root,
      //   icon: ICONS.document,
      //   roles: ['Administrator', 'Employee'],
      // },
      {
        title: 'Site Tasks',
        path: PATH_DASHBOARD.siteTaskDashboard,
        icon: ICONS.dashboard,
        roles: ['Administrator'],
        children: [
          {
            title: 'Operations Dashboard',
            path: PATH_DASHBOARD.siteTaskDashboard,
            roles: ['Administrator'],
          },
          {
            title: 'Task Templates',
            path: PATH_DASHBOARD.siteTaskTemplates,
            roles: ['Administrator'],
          },
          {
            title: 'Completion Templates',
            path: PATH_DASHBOARD.taskCompletionTemplates,
            roles: ['Administrator'],
          },
          {
            title:'Site Tasks',
            path: PATH_DASHBOARD.siteTaskAssignments,
            roles: ['Administrator'],
          },
          {
            title: 'Equipment',
            path: PATH_DASHBOARD.equipmentList,
            roles: ['Administrator'],
          },
          {
            title: 'Analytics',
            path: PATH_DASHBOARD.taskPerformanceChart,
            roles: ['Administrator'],
            children: [
              {
                title: 'Task Performance',
                path: PATH_DASHBOARD.taskPerformanceChart,
                roles: ['Administrator'],
              },
              {
                title: 'Category Distribution',
                path: PATH_DASHBOARD.taskCategoryDistribution,
                roles: ['Administrator'],
              },
              {
                title: 'Incomplete Tasks',
                path: PATH_DASHBOARD.incompleteTaskAnalysis,
                roles: ['Administrator'],
              },
              {
                title: 'Round Performance',
                path: PATH_DASHBOARD.roundPerformanceMetrics,
                roles: ['Administrator'],
              },
              {
                title: 'Guard Performance',
                path: PATH_DASHBOARD.guardPerformanceView,
                roles: ['Administrator'],
              },
            ],
          },
          {
            title: 'Equipment Reports',
            path: PATH_DASHBOARD.equipmentStatusReport,
            roles: ['Administrator'],
            children: [
              {
                title: 'Status Report',
                path: PATH_DASHBOARD.equipmentStatusReport,
                roles: ['Administrator'],
              },
              {
                title: 'Analytics',
                path: PATH_DASHBOARD.equipmentAnalytics,
                roles: ['Administrator'],
              },
            ],
          },
          {
            title: 'Gamification',
            path: PATH_DASHBOARD.gamificationSettings,
            roles: ['Administrator'],
            children: [
              {
                title: 'Settings',
                path: PATH_DASHBOARD.gamificationSettings,
                roles: ['Administrator'],
              },
              {
                title: 'Leaderboard',
                path: PATH_DASHBOARD.gamificationLeaderboard,
                roles: ['Administrator'],
              },
              {
                title: 'Achievements',
                path: PATH_DASHBOARD.achievementBadges,
                roles: ['Administrator'],
              },
              {
                title: 'Reports',
                path: PATH_DASHBOARD.gamificationReports,
                roles: ['Administrator'],
              },
            ],
          },
        ],
      },
    ],
  },
  // {
  //   subheader: "admin",
  //   roles: ["Administrator"],
  //   items: [
  //     {
  //       title: "manage users",
  //       path: PATH_DASHBOARD.userManagement.root,
  //       icon: ICONS.user,
  //       roles: ["Administrator"],
  //     },
  //   ],
  // },
  // {
  //   subheader: "admin",
  //   roles: ["Administrator"],
  //   items: [
  //     {
  //       title: "manage users",
  //       path: PATH_DASHBOARD.userManagement.root,
  //       icon: ICONS.user,
  //       roles: ["Administrator"],
       
  //     },
  //   ],
  // },
  {
    subheader: "admin",
    roles: ["Administrator"],
    items: [
      {
        title: "manage users",
        path: PATH_DASHBOARD.userManagement.root,
        icon: ICONS.user,
        roles: ["Administrator"],
      },
      // {
      //   title: "Email Templates",
      //   path: PATH_DASHBOARD.emailTemplates,
      //   icon: ICONS.file,
      //   roles: ["Administrator"],
      // },
    ],
  },
];

export default navConfig;
